import { ColumnStore } from "@bryntum/schedulerpro";
import { WIDGET_KEYS } from "../../other/constants/WidgetKeys.jsx";
import { GRID_COMBO_EDITOR_DEFAULTS } from "../../other/configs/globalConfig.jsx";
import {SETTING_TAB_WIDGET_KEYS} from "../../other/constants/OtherKeys.jsx";
import {tagWidget} from "../../other/utils/otherUtils.jsx";
import {
  EntityMainNameDefault,
  getCustomGroupRenderer,
} from "../../other/utils/utils.jsx";
import SwivuSortColumn from "./SwivuSortColumn.jsx";
import { EDITOR_KEYS } from "../../other/constants/EditorKeys.jsx";

class ResourceTypeColumn extends SwivuSortColumn {
  static get fields() {
    return ["swivuListTitle"]
  }

  static get $name() {
    return "ResourceTypeColumn";
  }

  get swivuIsTagColumn() {
    return true;
  }

  static get type() {
    return WIDGET_KEYS.columnResourceType;
  }

  static defaultFilterableOptions = {
    valueField: "id",
    displayField: "description",
    onSwivuEditMessage: "onClickSwivuEditMessage",
    ...GRID_COMBO_EDITOR_DEFAULTS,
  };

  static get defaults() {
    return {
      text: "Resource Type",
      field: "typeValue",
      flex: 1,
      filterType: "_swivu_settings",
      editor: false,
      groupRenderer(event) {
        return getCustomGroupRenderer(event);
      },
    };
  }

  onLoad(project, { editorHandler }) {
    this.project = project;
    this.editorHandler = editorHandler;
  }

  static isMatchValues(typeId, value) {
    if (typeId) {
      return typeId === value;
    }
    return false;
  }

  defaultRenderer({ record }) {
    const typeRecord = record._type;
    return tagWidget(typeRecord?.description);
  }

  renderer({ value, record }) {
    if (!record.isGroupHeader && this.project) {
      return EntityMainNameDefault({text: value})
    }
  }

  get swivuListItems() {
    return this?.project?.resourceTypeStore.query(() => true, true);
  }

  getSwivuListItemDisplayValue(record) {
    return `<span>${record.description}</span>`;
  }

  get canMultiSelectSwivuList() {
    return false
  }

  getSelectedSwivuListItem(record) {
    return record._type;
  }

  onSwivuListSelectionChange(record, _type) {
    record._type = _type[0];
  }

  onSwivuManageList() {
    const newRecord = this.project.resourceTypeStore.createRecord();
    this.editorHandler.openEditor(EDITOR_KEYS.settingGeneralEditor, newRecord, {
      user: newRecord,
      selectTabByTypeOnOpen: SETTING_TAB_WIDGET_KEYS.resourceTypeTab
    }, { by: "recordType", useExisting: true })
  }
}

ColumnStore.registerColumnType(ResourceTypeColumn);
